export default {
  DataForTag (state) {
    return state.tagData
  },
  DutyWorking (state) {
    return state.workIng
  },
  dutyArrangeProblem (state) {
    return state.dutyArrangeForProblem
  },
  normalDataProblem (state) {
    return state.dutyNormalForProblem
  },
  unNormalDataProblem (state) {
    return state.dutyUnNormalForProblem
  },
  signDataForProblemChange (state) {
    return state.signDataForProblem
  },
  unKnowWorkStatusForProblem (state) {
    return state.unKnowWorkStatus
  },
  scrollerHeight (state) {
    return state.scrollerHeight
  },
  router (state) {
    return state.router
  },
  highLightInfo (state) {
    return state.highLightInfo
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js